import {
	loginAPI,
	loginByTokenAPI,
	logoutAPI
} from '@/api/request/login.js'
import pages from '@/router/pages.js'
import router from '@/router/index.js'
export default {

	state: {
		token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
		userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
		username: localStorage.getItem('username') ? localStorage.getItem('username') : '',
		userRoleList: localStorage.getItem('userRoleList') ? localStorage.getItem('userRoleList').split(',') : [],
		unitInfo: localStorage.getItem('unitInfo') ? JSON.parse(localStorage.getItem('unitInfo')) : {},
		unitCode: localStorage.getItem('unitCode') ? localStorage.getItem('unitCode') : '',
		strTreeLevel: localStorage.getItem('strTreeLevel') ? localStorage.getItem('strTreeLevel') : '',
		intUnitLevel: localStorage.getItem('intUnitLevel') ? localStorage.getItem('intUnitLevel') : '',
		strLng: localStorage.getItem('strLng') ? localStorage.getItem('strLng') : '',
		strLat: localStorage.getItem('strLat') ? localStorage.getItem('strLat') : ''
	},
	getters: {},
	mutations: {
		setToken(state, token = '') {
			localStorage.setItem('token', token)
			state.token = token
		},
		setUserId(state, id = '') {
			localStorage.setItem('userId', id)
			state.userId = id
		},
		setUsername(state, username = '') {
			localStorage.setItem('username', username)
			state.username = username
		},
		setUserRoleList(state, list = []) {
			if (list && list.length > 0) {
				localStorage.setItem('userRoleLists', JSON.stringify(list))
				localStorage.setItem('userRoleList', list.join(','))
			}
			state.userRoleList = list
		},
		setUnitInfo(state, unit = {}) {
			const obj = JSON.stringify(unit)
			localStorage.setItem('unitInfo', obj)
			state.unitInfo = unit
		},
		setUnitCode(state, unitCode = '') {
			localStorage.setItem('unitCode', unitCode)
			state.unitCode = unitCode
		},
		setUnitLevel(state, intUnitLevel = '') {
			localStorage.setItem('intUnitLevel', intUnitLevel)
			state.intUnitLevel = intUnitLevel
		},
		setTreeLevel(state, strTreeLevel = '') {
			localStorage.setItem('strTreeLevel', strTreeLevel)
			state.strTreeLevel = strTreeLevel
		},
		setLng(state, strLng = '') {
			localStorage.setItem('strLng', strLng)
			state.strLng = strLng
		},
		setLat(state, strLat = '') {
			localStorage.setItem('strLat', strLat)
			state.strLat = strLat
		}
	},
	actions: {
		// 登录接口
		handleLogin({
			commit
		}, {
			username,
			password
		}) {
			const params = {
				strAccount: username,
				strPasswd: password,
				code: '123'
			}
			console.log(params);
			return new Promise((resolve, reject) => {
				loginAPI(params).then(res => {
					if (res.resultCode === 200) {
						localStorage.clear()
						//路由动态添加
						var arr = pages.pages
						// res.resultData.userMenuAuthority
						localStorage.setItem('routerArr', JSON.stringify(res.resultData.userMenuAuthority))// 储存路由配置
						//储存本地用户信息 
						localStorage.setItem('userData', JSON.stringify(res.resultData))
						
						// commit('setUnitCode',res.resultData.baseUnit.strCode)
						commit('setToken', res.resultData.accessToken)
						commit('setUserId', res.resultData.strUserGuid)
						commit('setUsername', res.resultData.strName)
						commit('setUserRoleList', res.resultData.userRoleList)
						commit('setUnitInfo', res.resultData.baseUnit)
						// commit('setRouterList', res.resultData.userMenuAuthority, { root: true })
						commit('setUnitLevel', res.resultData.baseUnit.intUnitLevel) // 当前账号等级
						commit('setTreeLevel', res.resultData.baseUnit.strTreeLevel) // 层级code
						commit('setLng', res.resultData.baseUnit.strLng) // 当前登录账号地图经度中心点
						commit('setLat', res.resultData.baseUnit.strLat) // 当前登录账号地图纬度中心点
						
						
						resolve(res.resultMsg)
					} else {
						reject(res.resultMsg)
					}
				}).catch(err => {
					reject(err)
				})
			})
		},
		handleTokenLogin({
			commit
		}, token) {
			return new Promise((resolve, reject) => {
				loginByTokenAPI(token).then(res => {
					if (res.resultCode === 200) {
						localStorage.clear()
						commit('setToken', res.resultData.accessToken)
						commit('setUserId', res.resultData.strUserGuid)
						commit('setUsername', res.resultData.strName)
						commit('setUserRoleList', res.resultData.userRoleList)
						commit('setUnitInfo', res.resultData.baseUnit)
						commit('setRouterList', res.resultData.userMenuAuthority, {
							root: true
						})
						commit('setUnitCode', res.resultData.baseUnit.strCode) // 当前登录单位code
						commit('setUnitLevel', res.resultData.baseUnit.intUnitLevel) // 当前账号等级
						commit('setTreeLevel', res.resultData.baseUnit.strTreeLevel) // 层级code
						commit('setLng', res.resultData.baseUnit.strLng) // 当前登录账号地图经度中心点
						commit('setLat', res.resultData.baseUnit.strLat) // 当前登录账号地图纬度中心点
						resolve(res.resultMsg)
					} else {
						resolve(res.resultMsg)
					}
				}).catch(err => {
					reject(err)
				})
			})
		},
		handleLogout() {
			return new Promise((resolve, reject) => {
				logoutAPI().then(res => {
					if (res.resultCode === 200) {
						localStorage.clear()
						resolve()
					} else {
						reject(res.resultMsg)
					}
				}).catch(err => {
					reject(err)
				})
			})
		}
	}
}
